import { getMobileProvider } from '@wix/gg-common-lib/utils';

type MobileProvider = 'apple' | 'google';

export const WIX_APP_STORE_URLS = {
  apple: 'https://apps.apple.com/app/id1545924344',
  google: 'https://play.google.com/store/apps/details?id=com.wix.admin',
} as const satisfies Record<MobileProvider, string>;

export interface WixAppStoreLink {
  url: string;
  provider: MobileProvider;
}

export function getWixAppStoreLink(): WixAppStoreLink | undefined {
  const provider = getMobileProvider();
  if (!provider) {
    return undefined;
  }
  return {
    url: WIX_APP_STORE_URLS[provider],
    provider,
  };
}
